import $ from "jquery";
import { coreUtils } from "./core-utils";
import { initAccordions, initTabs } from "./foundation-lite";
import { coreForms } from "../../components/molecules/forms/forms";
import { coreScrollToTop } from "../../components/molecules/scroll-to-top/scroll-to-top";
import { CookiePage } from "../../components/organisms/cookie-consent/cookie-consent-dialog";
import { coreEditorialSection } from "../../components/organisms/editorial-section/editorial-section";
import { coreFAQSection } from "../../components/organisms/faq-section/faq-section";
import { extendedToggleInit } from "../../components/organisms/extended-toggle/extended-toggle";
import { coreImageFeaturelist } from "../../components/organisms/image-feature-list-section/image-feature-list-section";
import { pageHeader } from "../../components/organisms/page-header/page-header";

window.$ = $;
window.jQuery = $;

/*
  This function is used by api to scroll to the top
*/
const initApi = () => {
  if (window) {
    window.addEventListener("message", (event) => {
      if (event.origin.indexOf("https://api.sebkortbank.com") !== -1) {
        if (event.data === "api-tab-changed") {
          window.scrollTo(0, 0);
        }
      }
    });
  }
};

// All components
const allComponents = function () {
  initAccordions();
  initTabs();

  // Inject SVG sprite sheets
//   coreUtils.loadSVGSpritesheet("/Static/images/icons.svg", "icons");

  // Enable wordbreaker
  coreUtils.wordBreaker();

  // Run components in core
  // coreUtils.init('.billboard-section', billboard);
  coreUtils.init(".editorial-section", coreEditorialSection);
  coreUtils.init(".faq-section", coreFAQSection);
  coreUtils.setBackButtonUrl();
  coreScrollToTop.scrollToTopButtonClick();
  coreUtils.init(".image-feature-list-section", coreImageFeaturelist);
  coreUtils.iFrameHeight();

  // Init Selectric
  coreForms.selectric();
  CookiePage(); // eslint-disable-line no-undef

  // Project unique components
  pageHeader.init();
  extendedToggleInit();

  // Init api components
  initApi();
};

// Init all scripts
$(document).ready(allComponents);

// Trigger or resize events
$(window).on("resize", coreUtils.wordBreaker);
$(window).on("scroll", coreScrollToTop.showHideScrollButton);
